// Base API configuration
const API_BASE_URL = 'https://jetpriyanshubackend.vercel.app';

// Common headers for API requests
const getHeaders = (includeAuth = false) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (includeAuth) {
    const session = localStorage.getItem('session');
    if (session) {
      const sessionData = JSON.parse(session);
      headers.Authorization = `Bearer ${sessionData.token}`;
    }
  }
  
  return headers;
};

// Generic API request function
export const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  const { includeAuth, ...fetchOptions } = options;
  const config = {
    method: 'GET',
    headers: getHeaders(includeAuth),
    ...fetchOptions,
  };

  if (config.body && typeof config.body === 'object' && config.method !== 'GET' && !(config.body instanceof FormData)) {
    config.body = JSON.stringify(config.body);
  }

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error);
    throw error;
  }
};

export { API_BASE_URL };
